import React from 'react';
// import {MedicinesCarousel} from './MedicinesCarousel.component';
import './MedicinesWithCategory.css';
import {MedicineCard} from './MedicineCard.component';
/*
props: {
    medicines: [{}],
    category: {id: number, name: string}
}
*/

// interface MedicineCategory {
//     id: number,
//     name: string
// }

// interface MedicinesWithCategoryProps {
//     key: number | string,
//     medicines: Medicine[],
//     category: MedicineCategory
// }

export const MedicinesWithCategory = (props) => {
    const {medicines, category, variant, onViewAllClick} = props;
    return <div key={category.id} id={`medicinesWithCategoryContainer-${category.id}`} className="medicinesWithCategoryContainer">
        <div className="medicinesCategoryNameContainer">
            <div>{category.name}</div>
            {
                variant !== 'detail'
                && <span className="viewAllLink" onClick={() => onViewAllClick && onViewAllClick(category)}>View All</span>
            }
        </div>

        <div className="medicinesListContainer">
            {
                medicines.map((medicine, index) => (

                    <MedicineCard key={index} medicine={medicine} variant={variant} />
                ))
            }
        </div>
    </div>;
};